import React from "react";
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


import AddIcon from '@mui/icons-material/AddCircle';

import Button from '@mui/material/Button';

import DepotGestion from 'components/Shared/DepotGestion';
import DepotGestionSelect from 'components/Shared/DepotGestionSelect';


const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    },

    depotGestion: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap'
    },

    depotGestionLeft: {
        flexGrow: '1'
    },
    
    chip: {
        margin: '8px 8px 8px 0px'
    }
    
});

const AddTransporteurCompteDialog = ({ classes, onClose, onClickSave, transporteur, depotsGestion }) => {

    const [compte, setCompte] = React.useState('');
    const [login, setLogin] = React.useState('');
    const [motPasse, setMotPasse] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [selectedDepotsGestion, setSelectedDepotsGestion] = React.useState([]);

    const [depotGestionIndex, setDepotGestionIndex] = React.useState(0);
    


    const removeDepot = (index) => {        
        var newDepots = [...selectedDepotsGestion];
        newDepots.splice(index, 1);
        setSelectedDepotsGestion(newDepots);
    };

    const addDepot = () => {
        var newDepot = depotsGestion[depotGestionIndex];

        var newDepots = [...selectedDepotsGestion, newDepot];
        setSelectedDepotsGestion(newDepots);
    };

        

    const save = () => {

        var transporteurCompte = {
            compte: compte,
            login: login,
            motPasse: motPasse,
            email: email,
            defaut: !transporteur.comptes || transporteur.comptes.length === 0,
            codesDepot: selectedDepotsGestion.map(x => x.codeDepot)
        };

        onClickSave(transporteurCompte);
        onClose();
    };

    return (
        <Dialog open>
            <DialogTitle>Nouveau compte pour le transporteur {transporteur.nom} ({transporteur.id})</DialogTitle>

            <DialogContent className={classes.dialogContent}>


                <FormControl margin="normal">
                    <FormLabel component="legend" required>Compte</FormLabel>
                    <TextField
                        id="compte"
                        name="compte"
                        placeholder="Saisir un identifiant de compte"
                        value={compte}
                        onChange={e => setCompte(e.target.value)}
                    />
                </FormControl>

                <FormControl margin="normal">
                    <FormLabel component="legend">Login</FormLabel>
                    <TextField
                        id="login"
                        name="login"
                        placeholder="Saisir un login"
                        value={login}
                        onChange={e => setLogin(e.target.value)}
                    />
                </FormControl>

                <FormControl margin="normal">
                    <FormLabel component="legend">Mot de passe</FormLabel>
                    <TextField
                        id="motPasse"
                        name="motPasse"
                        placeholder="Saisir un mot de passe"
                        value={motPasse}
                        onChange={e => setMotPasse(e.target.value)}
                    />
                </FormControl>


                <FormControl margin="normal">
                    <FormLabel component="legend">Email de contact</FormLabel>
                    <TextField
                        id="email"
                        name="email"
                        placeholder="Saisir un email de contact"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </FormControl>


                
                <FormControl margin="normal">
                    <FormLabel component="legend">Dépôts gestion</FormLabel>

                    <div style={{ display: 'flex' , flexWrap: 'wrap' }}>

                        {selectedDepotsGestion.map((dg, index) => {
                            return (
                                <FormControl key={index} className={classes.chip}>
                                    <DepotGestion depotGestion={dg} format="deletablechip" onDelete={(e) => removeDepot(index)} />
                                </FormControl>
                            );
                        })}
                    </div>
                </FormControl>


                <FormControl margin="normal" className={classes.formControl}>
                    <DepotGestionSelect value={depotGestionIndex} onChange={e => setDepotGestionIndex(e.target.value)} all={false} isRequired={false} autoFocus={false} label="Sélectionner un dépôt :"/>

                    <Button variant="contained" size="small" className={classes.button} onClick={(e) => addDepot()}>
                        <AddIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                        Ajouter ce dépot
                    </Button>
                </FormControl>








            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={save}
                    variant="contained"
                    color="secondary"
                    disabled={!compte}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(AddTransporteurCompteDialog);
